import React from "react";

const SecondaryStatsCard = ({ title, value, winner }) => {
  return (
    <div className="bg-gradient-to-r mb-1 from-orange-dark to-orange-light text-white shadow-lg rounded-lg p-1 flex items-center">
      <div className="flex flex-col items-start flex-grow ml-4">
        <h3 className="text-lg font-semibold">{title}</h3>
        <h3 className="text-md">{winner}</h3>
      </div>
      <div className="flex flex-col items-end mr-4 z-1">
        <div className="text-4xl font-bold leading-none">{value}</div>
        <div className="text-sm">Appointments</div>
      </div>

      {/* Title and Winner */}
    </div>
  );
};

export default SecondaryStatsCard;
